import React, { Component } from 'react';
import '../../assets/styles/Converter/Input.sass';

class Output extends Component {
  componentDidMount() {
    this.props.setOutput({ output: this.refs.output });
  }

  render() {
    return (
      <div className="Output">
        <input className="Output__field"
               ref="output"
               placeholder={this.props.placeholder}
               type="number"
               step="any"
               disabled />
      </div>
    );
  }
}

export default Output;
